import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import "./ReturnPolicy.css";

function ReturnPolicy() {
  const navigate = useNavigate();

  return (
    <>
    <Helmet>
  <title>Return, Refund & Shipping Policy – Vedonica International</title>

  <meta
    name="description"
    content="Learn about Vedonica International's return, refund, cancellation, and shipping policies for domestic and international orders."
  />
</Helmet>
    <div className="return-page">
      <div className="return-container">
        <div className="return-header">
          <span className="badge">Refund • Return • Shipping</span>
          <h1>Vedonica International Policy</h1>
          <p>
            Effective Date: April 2025 <br />
            At Vedonica International, customer satisfaction is our priority.
            Please review our Refund, Return & Shipping Policy carefully.
          </p>
        </div>

        <div className="return-grid">

          <div className="return-card">
            <h2>1. Return Eligibility</h2>
            <p>
              Products may be returned within 30 days from the date of delivery
              if they are in original, unused condition with all tags attached.
            </p>
          </div>

          <div className="return-card">
            <h2>2. Return Requirements</h2>
            <p>
              Returns must include original packaging, courier receipt,
              invoice, and all accompanying documents.
            </p>
          </div>

          <div className="return-card">
            <h2>3. Non-Eligible Returns</h2>
            <p>
              Used, damaged, altered, or incomplete products may not qualify
              for return or refund approval.
            </p>
          </div>

          <div className="return-card">
            <h2>4. Refund Process</h2>
            <p>
              Once your returned product is received and inspected, the refund
              process will be initiated immediately.
            </p>
          </div>

          <div className="return-card">
            <h2>5. Refund Timeline</h2>
            <p>
              Refunds are credited within 8–9 business days to your original
              payment source or selected refund method.
            </p>
          </div>

          <div className="return-card">
            <h2>6. Shipping Coverage</h2>
            <p>
              We ship across India and selected international destinations
              through trusted courier partners.
            </p>
          </div>

          <div className="return-card">
            <h2>7. Domestic Delivery</h2>
            <p>
              Orders are usually processed within 48 hours and delivered in
              5–7 business days. Remote areas may take longer.
            </p>
          </div>

          <div className="return-card">
            <h2>8. Delays & Exceptions</h2>
            <p>
              Delivery delays due to weather, courier disruptions, or force
              majeure events may occur and are beyond our control.
            </p>
          </div>

          <div className="return-card">
            <h2>9. Order Cancellation</h2>
            <p>
              Vedonica may cancel orders in cases of stock issues, lost
              shipments, or excessive delivery delays with full refund.
            </p>
          </div>

          <div className="return-card">
            <h2>10. Contact Support</h2>
            <p>
              For return, refund, or shipping assistance, contact our support
              team during business hours.
            </p>
          </div>

        </div>

        <div className="return-footer">
          <button className="home-btn" onClick={() => navigate("/")}>
            Back to Home
          </button>
        </div>
      </div>
    </div>
    </>
  );
}

export default ReturnPolicy;